import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Follow_up_status_v2 extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            vehs: [],
            allovehsl: false,
            txtsearch: '',
            cat: 'all',

        }
    }

    async componentDidMount() {
        this.current_status();
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    current_status = () => {
        let baseurl = myconfig.current_status;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            txtsearch: '',
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    vehs: res.data.datas,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.vehs.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>{value.loc}</td>
                    <td>{value.time}</td>
                    <td>{value.cargo_id}</td>
                    <td>{value.customer_id}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofarivalatloadpoint}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.dateofoffloading}</td>

                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    inputmgtfilter = (event) => {
        event.preventDefault();
        if (this.state.allovehsl) {
            var name = event.target.name;
            var value = event.target.value;
            this.setState({
                [name]: value,
            })
            let temp =this.state.allovehs.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
                cat: 'all',
            })
        }
    }
    inputmgtfilter2 = (event) => {
        event.preventDefault();
        if (this.state.allovehsl) {
            var name = event.target.name;
            var value = event.target.value;
            this.setState({
                [name]: value,
            })
            let temp =this.state.allovehs.datas;
            if (value != "" && value!="all") {
                temp = temp.filter(v => {
                    if (v.status.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
                txtsearch: '',
            })
        }
    }
    render() {
        return (
            <>
                <Nav type="follow_up_status_v2"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Vehicle Status</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Status</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch"
                                                       className="form-control float-right" value={this.state.txtsearch} onChange={this.inputmgtfilter} placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <select  name="cat"
                                                       className="form-control float-right" value={this.state.cat} onChange={this.inputmgtfilter2}>
                                               <option value="all">All</option>
                                               <option value="ALLOCATED_UNDER_DISPATCH">ALLOCATED_UNDER_DISPATCH</option>
                                               <option value="HEADING_TO_STATION">HEADING_TO_STATION</option>
                                               <option value="IN_TRANSIT_TO_LOAD_POINT">IN_TRANSIT_TO_LOAD_POINT</option>
                                               <option value="IN_TRANSIT_TO_OFFLOAD_POINT">IN_TRANSIT_TO_OFFLOAD_POINT</option>
                                               <option value="Not-Operational">Not-Operational</option>
                                               <option value="WAITING_FOR_ORDER">WAITING_FOR_ORDER</option>
                                               <option value="WAITING_TO_LOAD">WAITING_TO_LOAD</option>
                                               <option value="WAITING_TO_OFFLOAD">WAITING_TO_OFFLOAD</option>
                                               <option value="WAITING_TO_TRANSIT">WAITING_TO_TRANSIT</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Truck</th>
                                                <th>Status</th>
                                                <th>Orgin</th>
                                                <th>Destination</th>
                                                <th>Location</th>
                                                <th>Time</th>
                                                <th>Cargo</th>
                                                <th>Customer</th>
                                                <th>Arrival</th>
                                                <th>Arrival @ Load</th>
                                                <th>Loading</th>
                                                <th>Departure</th>
                                                <th>Arrival @ Unload</th>
                                                <th>Unloading</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Follow_up_status_v2;
